
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'

import { modalPrimaryButtonStyle } from '../styles/buttonStyles'

const BenefitsModal = ({
  open,
  onClose,
  onMouseEnter,
  onMouseLeave
}) => {
  const { t } = useTranslation([
    'translation',
    'regAdvantage',
    'referrInfo'
  ])

  const [hoverBtn, setHoverBtn] = useState(null)
  const [pressedBtn, setPressedBtn] = useState(null)

  const isMobileDevice =
    navigator.userAgentData?.mobile ??
    /Android.*Mobile|iPhone|iPod/i.test(navigator.userAgent)

  useEffect(() => {
    if (!open) return

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose()
    }

    window.addEventListener('keydown', handleKeyDown)

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [open, onClose])

  if (!open) return null

  const registrationBenefits = t('regAdvantage:INFOPAGE.LIST', {
    returnObjects: true
  })

  const referralBenefits = t('referrInfo:INFOPAGE.LIST', {
    returnObjects: true
  })

  return (
    <div
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        background: 'rgba(0,0,0,0.85)',
        borderRadius: 12,
        padding: isMobileDevice ? 16 : 24,
        width: isMobileDevice ? 'calc(100vw - 48px)' : 1150,
        maxWidth: isMobileDevice ? 'calc(100vw - 48px)' : undefined,
        boxSizing: 'border-box',
        maxHeight: '80vh',
        overflowY: 'auto',
        overflowX: isMobileDevice ? 'hidden' : undefined,
        fontSize: isMobileDevice ? 14 : undefined,
        lineHeight: isMobileDevice ? 1.45 : undefined,
        overflowWrap: isMobileDevice ? 'anywhere' : undefined,
        zIndex: 3600,
        border: '1.5px solid #107c6b',
        boxShadow: '0 12px 28px rgba(0,0,0,0.65)',
        color: '#E7DFEC'
      }}
    >
      <h2
        style={{
          marginTop: isMobileDevice ? 0 : -10,
          marginBottom: 6,
          fontSize: isMobileDevice ? 20 : undefined
        }}
      >
        {t('regAdvantage:INFOPAGE.TITLE')}
      </h2>

      {registrationBenefits.map((item, i) => (
        <p key={`reg-${i}`} style={{ margin: 0 }}>
          • {item}
        </p>
      ))}

      <h2
        style={{
          marginTop: 15,
          marginBottom: 6,
          fontSize: isMobileDevice ? 20 : undefined
        }}
      >
        {t('referrInfo:INFOPAGE.TITLE')}
      </h2>

      {referralBenefits.map((item, i) => (
        <p key={`ref-${i}`} style={{ margin: 0 }}>
          • {item}
        </p>
      ))}

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: 10
        }}
      >
        <button
          onClick={onClose}
          style={modalPrimaryButtonStyle(
            pressedBtn,
            'feature-close',
            hoverBtn === 'feature-close'
          )}
          onMouseEnter={() => setHoverBtn('feature-close')}
          onMouseLeave={() => {
            setHoverBtn(null)
            setPressedBtn(null)
          }}
          onMouseDown={() => setPressedBtn('feature-close')}
          onMouseUp={() => setPressedBtn(null)}
        >
          {t('CLOSE')}
        </button>
      </div>
    </div>
  )
}

export default BenefitsModal
